<template>
    <base-modal
        size="lg"
        hide-footer
        :title="$t('sensor_device.update_device')"
        @close="$emit('close')"
    >
        <div class="w-100 me-3">
            <span class="span-title">{{ $t('sensor_device.name') }}</span>
            <input
                v-model="localDevice.name"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': validationErrors.name }"
            >
        </div>
        <div class="w-100 me-3">
            <span class="span-title">{{ $t('sensor_device.device_id') }}</span>
            <input
                v-model="localDevice.device_id"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': validationErrors.device_id }"
            >
        </div>
        <div class="w-100 me-3">
            <span class="span-title">{{ $t('sensor_device.type') }}</span>
            <select
                v-model="localDevice.type"
                class="form-select form-select-sm"
                :class="{ 'is-invalid': validationErrors.type }"
            >
                <option v-for="t in deviceTypes" :key="t.value" :value="t.value">
                    {{ t.label }}
                </option>
            </select>
        </div>
        <div>
            <span class="form-check-label span-title">
                {{ $t('sensor_device.is_active') }}
            </span>
            <input
                v-model="localDevice.is_active"
                class="form-check-input"
                type="checkbox"
            >
        </div>

        <div class="button-container mt-4">
            <button class="btn btn-secondary form-button" @click="$emit('close')">
                {{ $t("common.cancel") }}
            </button>
            <button class="btn btn-primary form-button" @click="save">
                {{ $t("common.save") }}
            </button>
        </div>
    </base-modal>
</template>

<script>
import BaseModal from "@/components/BaseModal";

export default {
    name: 'DeviceEditModal',
    components: { BaseModal },
    props: {
        device: {
            type: Object,
            required: true
        },
        deviceTypes: {
            type: Array,
            required: true
        }
    },
    emits: ['close', 'save'],
    data() {
        return {
            localDevice: { ...this.device },
            validationErrors: { name: false, device_id: false, type: false }
        }
    },
    methods: {
        save() {
            this.validationErrors = { name: false, device_id: false, type: false };
            let isValid = true;

            if (!this.localDevice.name.trim()) { this.validationErrors.name = true; isValid = false; }
            if (!this.localDevice.device_id.trim()) { this.validationErrors.device_id = true; isValid = false; }
            if (!this.localDevice.type) { this.validationErrors.type = true; isValid = false; }

            if (isValid) this.$emit('save', this.localDevice);
        }
    }
}
</script>
